import React, { useEffect, useState } from "react";
// import ScrollableFeed from "react-scrollable-feed";
import {
  isSameSender,
  isLastMessage,
  isSameSenderMargin,
  isSameUser,
  isSameSenderSide,
  otherUserFirstMessage,
} from "../config/ChatLogics";
import Avatar from "@mui/material/Avatar";
import Tooltip from "@mui/material/Tooltip";
import "../../CSS/ChatMessage.css";

const ScrollableChat = ({ messages, userInfo }) => {
  // console.log("ScrollableChatProps", messages);

  const [messageTime, setMessageTime] = useState();
  useEffect(() => {
    let array = [];
    if (
      messages &&
      messages !== undefined &&
      messages !== null &&
      messages !== [] &&
      messages !== ""
    ) {
      messages.forEach((message) => {
        let onlyTime = message.updatedAt.split("T")[1];
        // console.log("onlyTime",onlyTime)
        let hours = onlyTime.split(":")[0];
        let minutes = onlyTime.split(":")[1];
        let amPm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12;
        hours = hours ? hours : 12;
        minutes = minutes < 10 ? minutes : minutes;
        var strTime = hours + ":" + minutes + " " + amPm;
        array.push({
          time: strTime,
        });
      });

      // console.log("array", array);
      setMessageTime(array);
    }
  }, [messages]);
  useEffect(() => {
    //+++++++++++++++++ScrollButtom++++++++++++++++++++
    document.getElementsByClassName("all_messages")[0].scrollTop =
      document.getElementsByClassName("all_messages")[0].scrollHeight;
    //+++++++++++++++++++++++++++++++++++++++++++++++++
  });
  return (
    // <div>
    <div className="all_messages">
      {messages &&
        messages.map((message, index) => (
          <div
            style={{
              display: "flex",
              justifyContent: isSameSenderSide(
                messages,
                message,
                index,
                userInfo._id
              ),
            }}
            key={message._id}
          >
            {(isSameSender(messages, message, index, userInfo._id) ||
              isLastMessage(messages, index, userInfo._id)) && (
              <Tooltip
                title={<h6>{message.sender[0].name}</h6>}
                placement="top-start"
              >
                <Avatar
                  src={message.sender[0].pic}
                  name={message.sender[0].name}
                  style={{
                    marginTop: "7px",
                    marginRight: "7px",
                    // marginTop:"7px",
                    cursor: "pointer",
                  }}
                />
              </Tooltip>
            )}
            {/* {otherUserFirstMessage(messages, message, index, userInfo._id) ? (
              <div className="message_sender_name">
                {message.sender[0].name}
              </div>
            ) : null} */}
            <span
              style={{
                backgroundColor: `${
                  message.sender[0]._id === userInfo._id ? "#54ac6f" : "#b0c753"
                }`,
                // borderRadius: `${
                //   message.sender[0]._id === userInfo._id
                //     ? "20px 20px 5px 20px"
                //     : "20px 20px 20px 5px"
                // }`,
                borderRadius: isSameUser(
                  messages,
                  message,
                  index,
                  userInfo._id
                ),
                padding: "5px 15px",
                maxWidth: "75%",
                margin: "2px",
                // marginTop: "15px",
                // color: isSameUser(messages, message, index,userInfo._id),
                // borderRight:"10px solid red",
                // borderTop:"5px solid transparent",
                // borderBottom:"5px solid transparent",
                marginLeft: isSameSenderMargin(
                  messages,
                  message,
                  index,
                  userInfo._id
                ),
                // marginTop: isSameUser(messages, message, index, userInfo._id)
                //   ? 3
                //   : 10,
                // fontSize: "25px",
              }}
            >
              {/* <div class="message_container">
                <div class="message">
                  <span>{message.content}</span>
                </div>
              </div> */}
              {otherUserFirstMessage(messages, message, index, userInfo._id) ? (
                <div className="message_sender_name">
                  {message.sender[0].name}
                </div>
              ) : null}
              <div className="message_content">{message.content}</div>
              <div className="message_time">
                {messageTime &&
                messageTime !== undefined &&
                messageTime[index] !== undefined
                  ? messageTime[index].time
                  : null}
              </div>
            </span>
          </div>
        ))}
    </div>
    // </div>
  );
};

export default ScrollableChat;
